// The builder runs inside the Next app, which owns the Chatwoot and Userback scripts.
export function getHostWindow(): Window {
  if (window.parent === window) return window;
  try {
    // cross-origin parent throws on property access
    void window.parent.Userback;
    return window.parent;
  } catch {
    return window;
  }
}

export function isSupportChatReady(): boolean {
  return Boolean(getHostWindow().$chatwoot?.toggle);
}

export function openSupportChat(user?: Partial<SessionUser>): boolean {
  const chatwoot = getHostWindow().$chatwoot;
  if (!chatwoot?.toggle) return false;

  if (user?.userId) {
    chatwoot.setUser?.(String(user.userId), {
      name: user.userName,
      email: user.userEmail,
    });
  }

  chatwoot.toggle('open');
  return true;
}
